'use strict';

blocks.register("waf-action", function () {
    return {
        link: function link($block) {
            $('form', $block).submit(function () {
                //@CommonWeb.URLPARM_SCROLLPOS
                $('[name=_scrl]', this).val($(document).scrollTop());
            });

            var scrollTop = $('[name=_scrl]', $block).val();

            if (scrollTop) {
                var scrollTop = parseInt(scrollTop, 10);
                if (!isNaN(scrollTop)) $(document).scrollTop(scrollTop);
            }
        }
    };
});